/* Brassyra editorial sections — configurator, product form, reveal */
(function () {
  'use strict';
  var COLORS = {
    'Black': ['Black', '#1E1C1A'], 'Blue': ['Sapphire blue', '#1E4E9A'], 'Green': ['Emerald green', '#1F6B4A'],
    'Orange': ['Sunset orange', '#E07A2E'], 'Pink': ['Blush pink', '#E8A9B8'], 'Red': ['Ruby red', '#C43A5A'],
    'Yellow': ['Golden yellow', '#E2B93B'], 'Purple': ['Royal purple', '#5D3E8E'], 'White': ['White', '#F4EFE6']
  };
  window.BZ_COLORS = COLORS;

  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    if (!fmt) return '$' + v;
    return fmt.replace(/\{\{\s*amount(_no_decimals)?\s*\}\}/, v).replace(/<[^>]+>/g, '');
  }
  function hookNum(s) { var m = String(s).match(/\d+/); return m ? parseInt(m[0], 10) : NaN; }

  function initConfig(root) {
    var variants = JSON.parse(root.getAttribute('data-variants') || '[]');
    var widths = JSON.parse(root.getAttribute('data-widths') || '{}') || {};
    var fmt = root.getAttribute('data-money-format') || '';
    var hookOpt = parseInt(root.getAttribute('data-hook-option') || '0', 10);
    var colorOpt = root.getAttribute('data-color-option');
    colorOpt = colorOpt === null || colorOpt === '' ? null : parseInt(colorOpt, 10);
    var productUrl = root.getAttribute('data-product-url') || '';
    var maxCm = 80;

    var hooksEl = root.querySelector('[data-bz-hooks]');
    var colorsEl = root.querySelector('[data-bz-colors]');
    var plate = root.querySelector('[data-bz-plate]');
    var dim = root.querySelector('[data-bz-dim]');
    var dimLabel = root.querySelector('[data-bz-dimlabel]');
    var idInput = root.querySelector('[data-bz-variant-id]');
    var atc = root.querySelector('[data-bz-atc]');

    var hookValues = [];
    variants.forEach(function (v) { var val = v['option' + (hookOpt + 1)]; if (hookValues.indexOf(val) === -1) hookValues.push(val); });
    hookValues.sort(function (a, b) { return hookNum(a) - hookNum(b); });
    var colorValues = [];
    if (colorOpt !== null) variants.forEach(function (v) { var val = v['option' + (colorOpt + 1)]; if (colorValues.indexOf(val) === -1) colorValues.push(val); });

    var sel = { hooks: null, color: null };
    var initId = (new URL(location.href)).searchParams.get('variant');
    var initV = variants.filter(function (v) { return String(v.id) === String(initId); })[0] || variants.filter(function (v) { return v.available; })[0] || variants[0];
    if (initV) { sel.hooks = initV['option' + (hookOpt + 1)]; if (colorOpt !== null) sel.color = initV['option' + (colorOpt + 1)]; }
    var preferred = root.getAttribute('data-default-hooks');
    if (preferred && !initId) { var pv = hookValues.filter(function (h) { return hookNum(h) === parseInt(preferred, 10); })[0]; if (pv) sel.hooks = pv; }
    var preferredColor = root.getAttribute('data-default-color');
    if (preferredColor && !initId && colorValues.indexOf(preferredColor) !== -1) sel.color = preferredColor;

    if (hooksEl) {
      hooksEl.innerHTML = '';
      hookValues.forEach(function (h) {
        var n = hookNum(h), w = widths[n] || widths[String(n)] || {};
        var b = document.createElement('button');
        b.type = 'button';
        b.innerHTML = '<b>' + n + '</b><small>' + (w['in'] ? w['in'] + ' in' : '') + '</small>';
        b.setAttribute('aria-label', n + ' hooks' + (w['in'] ? ', ' + w['in'] + ' inches' : ''));
        b.addEventListener('click', function () { sel.hooks = h; render(); });
        hooksEl.appendChild(b);
      });
    }
    if (colorsEl) {
      colorsEl.innerHTML = '';
      colorValues.forEach(function (c) {
        var meta = COLORS[c] || [c, '#999'];
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', meta[0]);
        b.innerHTML = '<i style="background:' + meta[1] + '"></i>';
        b.addEventListener('click', function () { sel.color = c; render(); });
        colorsEl.appendChild(b);
      });
    }

    function current() {
      return variants.filter(function (v) {
        return v['option' + (hookOpt + 1)] === sel.hooks && (colorOpt === null || v['option' + (colorOpt + 1)] === sel.color);
      })[0];
    }

    function render() {
      var v = current();
      var n = hookNum(sel.hooks);
      var w = widths[n] || widths[String(n)] || {};
      var pct = w.cm ? Math.min(100, w.cm / maxCm * 100) : 100;

      if (hooksEl) Array.prototype.forEach.call(hooksEl.children, function (b, i) { b.setAttribute('aria-pressed', String(hookValues[i] === sel.hooks)); });
      if (colorsEl) Array.prototype.forEach.call(colorsEl.children, function (b, i) { b.setAttribute('aria-pressed', String(colorValues[i] === sel.color)); });

      if (plate) { plate.style.width = pct + '%'; var hooksHtml = ''; for (var i = 0; i < (n || 0); i++) hooksHtml += '<i></i>'; plate.innerHTML = hooksHtml; }
      if (dim) dim.style.width = pct + '%';
      if (dimLabel) {
        dimLabel.textContent = (w['in'] ? w['in'] + ' in · ' : '') + (w.cm ? w.cm + ' cm' : '');
        if (pct > 72) { dimLabel.style.left = 'auto'; dimLabel.style.right = '0'; } else { dimLabel.style.right = 'auto'; dimLabel.style.left = 'calc(' + pct + '% + 10px)'; }
      }
      var priceText = v ? money(v.price, fmt) : '';
      root.querySelectorAll('[data-bz-price]').forEach(function (e) { e.textContent = priceText; });
      document.querySelectorAll('[data-bz-price-mirror="' + root.id + '"]').forEach(function (e) { e.textContent = priceText; });
      var sku = root.querySelector('[data-bz-sku]'); if (sku && v) sku.textContent = v.sku || '';
      var inl = root.querySelector('[data-bz-hooks-label]'); if (inl) inl.textContent = n + ' hooks' + (w['in'] ? ' · ' + w['in'] + ' in / ' + w.cm + ' cm' : '');
      var cn = root.querySelector('[data-bz-colorname]'); if (cn && sel.color) cn.textContent = (COLORS[sel.color] || [sel.color])[0];
      var cfg = document.querySelector('[data-bz-cfg-mirror="' + root.id + '"]'); if (cfg) cfg.textContent = n + ' hooks' + (sel.color ? ' · ' + (COLORS[sel.color] || [sel.color])[0].split(' ')[0] : '');
      if (idInput && v) idInput.value = v.id;
      if (atc) {
        var lbl = atc.querySelector('[data-bz-atc-label]');
        if (v && v.available) { atc.disabled = false; if (lbl) lbl.textContent = atc.getAttribute('data-label-add'); }
        else { atc.disabled = true; if (lbl) lbl.textContent = atc.getAttribute('data-label-sold'); }
      }
      var link = root.querySelector('[data-bz-configure]'); if (link && v && productUrl) link.href = productUrl + '?variant=' + v.id;
      if (root.hasAttribute('data-sync-url') && v && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
    }
    render();
  }

  function initSticky() {
    var bar = document.querySelector('[data-bz-stickybar]'); var anchor = document.querySelector('[data-bz-sticky-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { bar.classList.toggle('show', !x.isIntersecting && x.boundingClientRect.top < 0); }); }, { threshold: 0 });
    io.observe(anchor);
    var btn = bar.querySelector('[data-bz-sticky-submit]'); var form = document.querySelector('[data-bz-product-form]');
    if (btn && form) btn.addEventListener('click', function () { var a = form.querySelector('[data-bz-atc]'); if (a && !a.disabled) a.click(); });
  }

  function initReveal() {
    if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches || !('IntersectionObserver' in window)) return;
    var els = Array.prototype.slice.call(document.querySelectorAll('.bz-rv'));
    els.forEach(function (el) { if (el.getBoundingClientRect().top > window.innerHeight * 0.9) el.classList.add('pre'); });
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.remove('pre'); io.unobserve(x.target); } }); }, { threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  function boot() {
    document.querySelectorAll('[data-bz-config]').forEach(function (r) { if (!r.__bz) { r.__bz = true; initConfig(r); } });
    initSticky(); initReveal();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
